var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h4',{staticClass:"text-center mb-5 mt-px"},[_vm._v(_vm._s(_vm.title))]),_c('iframe',{attrs:{"src":`https://view.officeapps.live.com/op/embed.aspx?src=${_vm.src}`,"width":"100%","height":"900px","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }